import { createFileRoute } from "@tanstack/react-router"

import { GuidePage } from "../components/landing"
import { medicareGuide } from "../content/medicare-levy-calculator"
import { guideSeo } from "./guides.$slug"

const PATH = "/medicare-levy-calculator"

/** Free Medicare levy calculator (T917); the content is a `Guide`, the URL is top level (copy-products.md). */
export const medicareSeo = () => guideSeo(medicareGuide, PATH)

export const Route = createFileRoute("/_brand-layout/medicare-levy-calculator")({
  head: () => {
    const { meta, links, scripts } = medicareSeo()
    return { meta, links, scripts }
  },
  component: () => <GuidePage guide={medicareGuide} />,
})
